<template>
  <!--Add to Calendar Button - https://add-to-calendar-button.com/configuration / https://add-to-calendar-button.com/use-with-vue -->
  <add-to-calendar-button
    :name="calendarEventData.name"
    :description="calendarEventData.description"
    :startDate="calendarEventData.startDate"
    :startTime="calendarEventData.startTime"
    :endDate="calendarEventData.endDate"
    :endTime="calendarEventData.endTime"
    :timeZone="calendarEventData.timeZone"
    :location="calendarEventData.location"
    options="'Apple','Google','iCal','Outlook.com','Yahoo'"
    buttonStyle="custom"
    :customCss="stylesUrl"
    buttonsList
    hideIconButton
    hideBackground
    size="5"
    lightMode="bodyScheme"
  ></add-to-calendar-button>
</template>
<script>
  import 'add-to-calendar-button'

  export default {
    name: 'AddToCalendar',
    props: {
      calendarEventData: {
        type: Object,
        required: true
      },
      stylesUrl: {
        type: String,
        required: true,
      },
    },
  }

</script>
